function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var webTrackBrowser_cjs = {};

(function (exports) {

	Object.defineProperty(exports, '__esModule', { value: true });

	class WebTracker {
	    constructor(opt) {
	        var _a, _b;
	        this.timer = null;
	        this.time = 10;
	        this.count = 10;
	        this.arr = [];
	        this.time = (_a = opt.time) !== null && _a !== void 0 ? _a : 10; //定义时间，number类型
	        this.count = (_b = opt.count) !== null && _b !== void 0 ? _b : 10; //定义数据条数，number类型
	        this.url = 'https://' + opt.project + '.' + opt.host + '/logstores/' + opt.logstore + '/track';
	        this.opt = opt;
	        if (opt.installUnloadHook && typeof opt.installUnloadHook === 'function') {
	            opt.installUnloadHook(() => {
	                this.platformSend(this.assemblePayload());
	            });
	        }
	    }
	    assemblePayload(arr = this.arr) {
	        const payload = {
	            __logs__: arr,
	        };
	        if (this.opt.tags) {
	            payload.__tags__ = this.opt.tags;
	        }
	        if (this.opt.topic) {
	            payload.__topic__ = this.opt.topic;
	        }
	        if (this.opt.source) {
	            payload.__source__ = this.opt.source;
	        }
	        return JSON.stringify(payload);
	    }
	    platformSend(payloadStr) {
	        if (this.opt.sendPayload && typeof this.opt.sendPayload === 'function') {
	            this.opt.sendPayload(this.url, payloadStr);
	        }
	    }
	    transString(obj) {
	        let newObj = {};
	        for (let i in obj) {
	            if (typeof obj[i] == 'object') {
	                newObj[i] = JSON.stringify(obj[i]);
	            }
	            else {
	                newObj[i] = String(obj[i]);
	            }
	        }
	        return newObj;
	    }
	    sendImmediateInner() {
	        if (this.arr && this.arr.length > 0) {
	            this.platformSend(this.assemblePayload());
	            if (this.timer != null) {
	                clearTimeout(this.timer);
	                this.timer = null;
	            }
	            this.arr = [];
	        }
	    }
	    sendInner() {
	        if (this.timer) {
	            if (this.arr.length >= this.count) {
	                clearTimeout(this.timer);
	                this.timer = null;
	                this.sendImmediateInner();
	            }
	        }
	        else {
	            const that = this;
	            if (this.arr.length >= this.count || this.time <= 0) {
	                this.sendImmediateInner();
	            }
	            else {
	                this.timer = setTimeout(function () {
	                    that.sendImmediateInner();
	                }, this.time * 1000);
	            }
	        }
	    }
	    send(originLog) {
	        const obj = this.transString(originLog);
	        this.arr.push(obj);
	        this.sendInner();
	    }
	    sendImmediate(originLog) {
	        const obj = this.transString(originLog);
	        this.arr.push(obj);
	        this.sendImmediateInner();
	    }
	    sendBatchLogs(originLogs) {
	        const logs = originLogs.map((originLog) => this.transString(originLog));
	        this.arr.push(...logs);
	        this.sendInner();
	    }
	    sendBatchLogsImmediate(originLogs) {
	        const logs = originLogs.map((originLog) => this.transString(originLog));
	        this.arr.push(...logs);
	        this.sendImmediateInner();
	    }
	}

	function sendBeacon(url, payload) {
	    if (navigator && navigator.sendBeacon) {
	        return navigator.sendBeacon(`${url}?APIVersion=0.6.0`, payload);
	    }
	    return false;
	}
	function sendUseXhr(url, reqPayload) {
	    const httpRequest_ = new window.XMLHttpRequest();
	    httpRequest_.open('POST', url, true);
	    httpRequest_.setRequestHeader('x-log-apiversion', '0.6.0');
	    httpRequest_.setRequestHeader('x-log-bodyrawsize', reqPayload.length.toString());
	    const blob = new Blob([reqPayload], {
	        type: 'application/x-protobuf',
	    });
	    httpRequest_.send(blob);
	}
	function send(url, payload) {
	    try {
	        if (!sendBeacon(url, payload)) {
	            sendUseXhr(url, payload);
	        }
	    }
	    catch (ex) {
	        if (window && window.console && typeof window.console.error === 'function') {
	            console.error('Failed to log to ali log service because of this exception:\n' + ex);
	            console.error('Failed log data:', url);
	        }
	    }
	}
	class WebTrackerBrowser extends WebTracker {
	    constructor(opt) {
	        const superOpt = Object.assign({}, opt, {
	            installUnloadHook: (hook) => {
	                window.addEventListener('beforeunload', () => {
	                    hook();
	                });
	            },
	            sendPayload: (url, payload) => {
	                send(url, payload);
	            },
	        });
	        super(superOpt);
	    }
	}

	function defineGlobal(global, name, api) {
	    global[name] = api;
	}
	defineGlobal(window, 'SLS_Tracker', WebTrackerBrowser);

	exports["default"] = WebTrackerBrowser;
	exports.defineGlobal = defineGlobal;
	
} (webTrackBrowser_cjs));

var SlsTracker = /*@__PURE__*/getDefaultExportFromCjs(webTrackBrowser_cjs);

var getOs = () => {
    const ua = window.navigator.userAgent;
    const platform = window.navigator.platform;
    const isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1;
    if (isAndroid)
        return 'android';
    const isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (isiOS)
        return 'iOS';
    const isMac = 'Mac68K' == platform || 'MacPPC' == platform || 'Macintosh' == platform || 'MacIntel' == platform;
    if (isMac)
        return 'Mac';
    const isWindows = 'Win32' == platform || 'Windows' == platform;
    if ('X11' === platform && !isWindows && !isMac)
        return 'Unix';
    const isLinux = platform.indexOf('Linux') > -1;
    if (isLinux)
        return 'Linux';
    if (isWindows) {
        if (ua.indexOf('Windows NT 5.0') > -1 || ua.indexOf('Windows 2000') > -1)
            return 'Win2000';
        if (ua.indexOf('Windows NT 5.1') > -1 || ua.indexOf('Windows XP') > -1)
            return 'WinXP';
        if (ua.indexOf('Windows NT 5.2') > -1 || ua.indexOf('Windows 2003') > -1)
            return 'Win2003';
        if (ua.indexOf('Windows NT 6.0') > -1 || ua.indexOf('Windows Vista') > -1)
            return 'WinVista';
        if (ua.indexOf('Windows NT 6.1') > -1 || ua.indexOf('Windows 7') > -1)
            return 'Win7';
        if (ua.indexOf('Windows NT 10.0') > -1 || ua.indexOf('Windows 10') > -1)
            return 'Win10';
    }
    return 'default';
};
function getOsVersion() {
    const ua = navigator.userAgent;
    const isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1;
    const isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    const isMac = 'Mac68K' == navigator.platform ||
        'MacPPC' == navigator.platform ||
        'Macintosh' == navigator.platform ||
        'MacIntel' == navigator.platform;
    const isWindows = 'Win32' == navigator.platform || 'Windows' == navigator.platform;
    try {
        if (isAndroid)
            return 'Android' + ua.split('Android')[1].split(';')[0];
        if (isiOS)
            return 'ioS ' + ua.split('OS')[1].split(' ')[1];
        if (isMac)
            return 'mac' + ua.split('Mac OS X')[1].split(')')[0];
    }
    catch (e) {
        return 'error';
    }
    return isWindows
        ? ua.indexOf('Windows NT 5.0') > -1 || ua.indexOf('Windows 2000') > -1
            ? 'Win2000'
            : ua.indexOf('Windows NT 5.1') > -1 || ua.indexOf('Windows XP') > -1
                ? 'WinXP'
                : ua.indexOf('Windows NT 5.2') > -1 || ua.indexOf('Windows 2003') > -1
                    ? 'Win2003'
                    : ua.indexOf('Windows NT 6.0') > -1 || ua.indexOf('Windows Vista') > -1
                        ? 'WinVista'
                        : ua.indexOf('Windows NT 6.1') > -1 || ua.indexOf('Windows 7') > -1
                            ? 'Win7'
                            : ua.indexOf('Windows NT 10.0') > -1 || ua.indexOf('Windows 10') > -1
                                ? 'Win10'
                                : 'Windows'
        : '其他';
}

var getUrlParamas = (url = window.location.href) => {
    let vars = {};
    url.replace(/[?&]+([^=&]+)=([^&#]*)/gi, (m, k, v) => {
        vars[k] = v;
        return m;
    });
    return vars;
};

var SOURCETYPE;
(function (SOURCETYPE) {
    SOURCETYPE[SOURCETYPE["H5"] = 3] = "H5";
    SOURCETYPE[SOURCETYPE["MINI"] = 4] = "MINI";
    SOURCETYPE[SOURCETYPE["WEB"] = 5] = "WEB";
})(SOURCETYPE || (SOURCETYPE = {}));
var EVNTYPE;
(function (EVNTYPE) {
    EVNTYPE["Production"] = "production";
    EVNTYPE["Test"] = "test";
    EVNTYPE["Development"] = "development";
    EVNTYPE["Default"] = "default";
    EVNTYPE["Gray"] = "gray";
})(EVNTYPE || (EVNTYPE = {}));

// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

const byteToHex = [];

for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}

function unsafeStringify(arr, offset = 0) {
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  return (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
}

const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var native = {
  randomUUID
};

function v4(options, buf, offset) {
  if (native.randomUUID && !buf && !options) {
    return native.randomUUID();
  }

  options = options || {};
  const rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return unsafeStringify(rnds);
}

/*! js-cookie v3.0.1 | MIT */
/* eslint-disable no-var */
function assign (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target
}
/* eslint-enable no-var */

/* eslint-disable no-var */
var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
  },
  write: function (value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    )
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init (converter, defaultAttributes) {
  function set (key, value, attributes) {
    if (typeof document === 'undefined') {
      return
    }

    attributes = assign({}, defaultAttributes, attributes);

    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }

    key = encodeURIComponent(key)
      .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
      .replace(/[()]/g, escape);

    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue
      }

      stringifiedAttributes += '; ' + attributeName;

      if (attributes[attributeName] === true) {
        continue
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }

    return (document.cookie =
      key + '=' + converter.write(value, key) + stringifiedAttributes)
  }

  function get (key) {
    if (typeof document === 'undefined' || (arguments.length && !key)) {
      return
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');

      try {
        var foundKey = decodeURIComponent(parts[0]);
        jar[foundKey] = converter.read(value, foundKey);

        if (key === foundKey) {
          break
        }
      } catch (e) {}
    }

    return key ? jar[key] : jar
  }

  return Object.create(
    {
      set: set,
      get: get,
      remove: function (key, attributes) {
        set(
          key,
          '',
          assign({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function (attributes) {
        return init(this.converter, assign({}, this.attributes, attributes))
      },
      withConverter: function (converter) {
        return init(assign({}, this.converter, converter), this.attributes)
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  )
}

var api = init(defaultConverter, { path: '/' });

var name = "@xwfe/web-track-browser";
var version = "0.2.1";
var description = "";
var main = "dist/web-track-browser.cjs.js";
var module = "dist/web-track-browser.esm.js";
var unpkg = "dist/web-track-browser.js";
var types = "dist/web-track-browser.d.ts";
var files = [
	"index.js",
	"dist"
];
var scripts = {
	test: "echo \"Error: no test specified\" && exit 1"
};
var keywords = [
];
var author = "";
var license = "ISC";
var dependencies = {
	"@aliyun-sls/web-track-browser": "^0.0.3",
	"@xwfe/web-track-core": "workspace:*",
	"js-cookie": "^3.0.1",
	uuid: "^9.0.0"
};
var devDependencies = {
	"@types/uuid": "^8.3.4",
	"@types/js-cookie": "^3.0.3"
};
var packagejson = {
	name: name,
	version: version,
	description: description,
	main: main,
	module: module,
	unpkg: unpkg,
	types: types,
	files: files,
	scripts: scripts,
	keywords: keywords,
	author: author,
	license: license,
	dependencies: dependencies,
	devDependencies: devDependencies
};

class XwLog {
    constructor(opts) {
        this.options = opts;
        this.baseOptions = {
            host: 'cn-beijing.log.aliyuncs.com',
            project: 'xw-fe-logs'
        };
        this.tracker = new SlsTracker(Object.assign({}, this.baseOptions, opts));
        this.sysData = this.getSysData(opts);
        this.debug = opts.debug || false;
    }
    getSysData(opts) {
        const urlParams = getUrlParamas();
        const xwIdCache = window.localStorage.getItem('xw_id');
        let xwId = xwIdCache ? xwIdCache : v4();
        const appVersion = this.getAppVersion();
        if (!xwIdCache) {
            window.localStorage.setItem('xw_id', xwId);
        }
        const sysData = {
            language: window.navigator.language,
            os_version: getOsVersion(),
            channel: 'default',
            client_ip: 'default',
            app_version: appVersion,
            os: getOs(),
            resolution: 'default',
            brand: 'default',
            device_model: 'default',
            carrier: 'default',
            access: 'default',
            bury_type: 'default',
            ab_group: 'default',
            city: 'default',
            province: 'default',
            ua: window.navigator.userAgent,
            source_id: urlParams.xeswx_sourceid || 'default',
            pre_bury_id: 'default',
            pre_page_id: 'default',
            level_one: 'default',
            level_two: 'default',
            level_three: 'default',
            xw_id: xwId,
            session_id: 'default',
            user_id: api.get('stu_id') || 'default',
            sdk_version: packagejson.version,
            business_type: opts.business_type || 'default',
            env_type: opts.env_type || EVNTYPE.Default,
            source_type: opts.source_type || SOURCETYPE.H5
        };
        return Object.assign({}, sysData, opts.sysData);
    }
    getFinalData(data) {
        const currentTime = new Date().getTime();
        const buringPointInfo = data.click_id.split('_');
        if (data.user_id)
            this.sysData.user_id = data.user_id;
        if (!data.click_id)
            data.click_id = 'default';
        this.sysData.bury_type = buringPointInfo[0] || 'default';
        this.sysData.level_one = buringPointInfo[2] || 'default';
        this.sysData.level_two = buringPointInfo[3] || 'default';
        this.sysData.level_three = buringPointInfo[4] || 'default';
        return {
            sys: this.sysData,
            bus: {
                pagename: data.pagename || window.document.title || 'default',
                project_id: buringPointInfo[1] || 'default',
                log_project: this.options.project || this.baseOptions.project,
                log_store: this.options.logstore,
                bury_id: data.click_id,
                url: window.location.href,
                data: data
            },
            appid: this.options.logstore,
            user_id: this.sysData.user_id || 'default',
            timestamp: currentTime
        };
    }
    getAppVersion() {
        const UA = window.navigator.userAgent;
        const isXwApp = /subject_jzh/.test(UA);
        const isNewXwApp = /xwApp/.test(UA);
        let reg = null;
        let appTip = '';
        if (isXwApp) {
            reg = /Version\/(\d+)/g;
            appTip = 'isXwApp';
        }
        if (isNewXwApp) {
            reg = /Version\/xwApp\/(\d+)/g;
            appTip = 'isNewXwApp';
        }
        if (isXwApp || isNewXwApp) {
            const res = reg.exec(UA);
            if (res) {
                return res[1];
            }
            else {
                return `${appTip}: ${JSON.stringify(res)}`;
            }
        }
        return 'default';
    }
    send(data) {
        const logData = this.getFinalData(data);
        if (this.debug)
            console.info(logData);
        this.tracker.send(logData);
    }
    sendImmediate(data) {
        const logData = this.getFinalData(data);
        if (this.debug)
            console.info(logData);
        this.tracker.sendImmediate(logData);
    }
    sendBatchLogs(datas) {
        if (!datas || datas.length <= 0)
            return;
        let logDatas = [];
        datas.forEach((data) => {
            logDatas.push(this.getFinalData(data));
        });
        if (this.debug)
            console.info(logDatas);
        this.tracker.sendBatchLogs(logDatas);
    }
    sendBatchLogsImmediate(datas) {
        if (!datas || datas.length <= 0)
            return;
        let logDatas = [];
        datas.forEach((data) => {
            logDatas.push(this.getFinalData(data));
        });
        if (this.debug)
            console.info(logDatas);
        this.tracker.sendBatchLogsImmediate(logDatas);
    }
    setUserInfo(userId = 'default') {
        this.sysData.user_id = userId;
    }
    setSysData(otherSysData) {
        this.sysData = Object.assign(this.sysData, otherSysData);
    }
}
XwLog.SOURCETYPE = SOURCETYPE;
XwLog.EVNTYPE = EVNTYPE;

export { XwLog as default };
